import { render, staticRenderFns } from "./ShipperListPage.vue?vue&type=template&id=e6aa2278&scoped=true&"
import script from "./ShipperListPage.vue?vue&type=script&lang=js&"
export * from "./ShipperListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6aa2278",
  null
  
)

export default component.exports